import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetCriteria,
  SaveCriteria,
  CreateCriteria,
  DeleteCriteria,
  GetCriteriaCalculatedRange,
  GetPossibleStructureValues,
  CheckMissingPLZForGroupedPlz,
};

function GetCriteria(contractId, versionId, editionId, onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteria`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      console.log(error);
      onError(error);
    });
}

function DeleteCriteria(
  contractId,
  versionId,
  editionId,
  criteriaId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteria/${criteriaId}`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      console.log(error);
      onError(error);
    });
}

function GetCriteriaCalculatedRange(
  contractId,
  versionId,
  editionId,
  criteriaId,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteria/${criteriaId}?calculateRange=true`,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      console.log(error);
      onError(error);
    });
}

function SaveCriteria(
  contractId,
  versionId,
  editionId,
  criteria,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteria/${criteria.id}`,
      criteria,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function CreateCriteria(
  contractId,
  versionId,
  editionId,
  criteria,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/criteria`,
      criteria,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function GetPossibleStructureValues(
  contractId,
  versionId,
  editionId,
  criteriaStructureId,
  previousSettings,
  getAllValues,
  getFullyQualified,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${editionId}/mindestlohn/structure/${criteriaStructureId}?all=${getAllValues ? "true" : "false"}&fullyQualified=${getFullyQualified ? "true" : "false"}`,
      previousSettings,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}

function CheckMissingPLZForGroupedPlz(
  contractId,
  versionId,
  configurationId,
  criteria,
  language,
  onSuccess,
  onError,
) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL +
        `/contracts/${contractId}/versions/${versionId}/configurations/${configurationId}/mindestlohn/criteria/checkMissingPlz` +
        (language ? `?language=${language}` : ""),
      criteria,
      headers,
    )
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
